import { OPERATOR, LOGICAL } from './request';
export default {
  props: ['item', 'splitFieldList', 'leve', 'index', 'index2', 'index3'],
  data() {
    return {
      OPERATOR,
      LOGICAL
    };
  },
  methods: {
    chenckFun(val, type) {
      let show = false;
      console.log(this.leve == 3 && type && val.field && val.operator && val.value && val.logical);
      if (val.field && val.operator && val.value && val.logical && this.leve != 3 || this.leve == 3 && type && val.field && val.operator && val.value && val.logical) {
        show = true;
      }
      return show;
    },
    groudFun() {
      this.$emit('addGround', this.leve, this.index, this.index2, this.index3);
    },
    leveFun() {
      this.$emit('addLeve', this.leve, this.index, this.index2, this.index3);
    },
    delFun() {
      this.$emit('delItem', this.leve, this.index, this.index2, this.index3);
    }
  }
};